<div class="row" style="margin-top:75px">
  <div class="col-12">
    <div class="row mb-2">
      <div class="col-12 col-md-3">
        <input type="text" value="" class="form-control form-control-sm" placeholder="Search..." (ngModelChange)="searchChange($event)" [ngModel]="searchText" />
      </div>
      <div class="col-12 col-md-9">
        <div class="row">
          <div class="col-3">
            <div class="alert alert-info text-center p-1 mb-0">
              {{saveMode.toUpperCase()}} MODE
            </div>
          </div>
          <div class="col-9">
            <div class="alert alert-danger text-center p-1 mb-0" [hidden]="(error_msg === '')">
              <i class="fas fa-fw fa-lg fa-info-circle me-1"></i>{{error_msg}}
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="grid_sizer">
          <ag-grid-angular style="height:100% !important"
                           class="ag-theme-alpine"
                           [gridOptions]="gridOptions"
                           [headerHeight]="29"
                           [rowHeight]="26"
                           [rowData]="rowData"
                           [columnDefs]="columnDefs"
                           [pagination]="false"
                           (gridReady)="onGridReady($event)"
                           [rowSelection]="rowSelection"
                           (selectionChanged)="onSelectionChanged($event)"
                           >
          </ag-grid-angular>
          <div id="add_row">
            <div class="col-12">
              <table class="table table-sm bg_bonemd">
                <tbody>
                  <tr>
                    <td style="width:125px !important">
                      <select class="form-select form-select-sm" [disabled]="disableFilters" (change)="getEntityFilter()" [(ngModel)]="filters.client" id="flt_client">
                        <option value="">- Client -</option>
                        <option *ngFor="let client of listClients; index as i" [value]="client.id">
                          {{client.ref_data}}
                        </option>
                      </select>

                    </td>
                    <td style="width: 125px !important">
                      <select class="form-select form-select-sm add_filter" [disabled]="disableFilters" (change)="getAccountFilter('a')" [(ngModel)]="filters.entityA" id="flt_entitya">
                        <option value="">- Entity A -</option>
                        <option *ngFor="let entity1 of listEntities" [value]="entity1.id">{{ entity1.ref_data }}</option>
                      </select>
                    </td>
                    <td style="width: 350px !important">
                      <select class="form-select form-select-sm add_filter" [disabled]="disableFilters" [(ngModel)]="filters.entityAAccount" id="flt_accounta">
                        <option value="">- Entity A Account -</option>
                        <option *ngFor="let account of listAccountsA" [value]="account.id">{{ account.ref_data }}</option>
                      </select>
                    </td>
                    <td style="width: 125px !important">
                      <select class="form-select form-select-sm add_filter" (change)="getAccountFilter('b')" [disabled]="disableFilters" [(ngModel)]="filters.entityB" id="flt_entityb">
                        <option value="">- Entity B -</option>
                        <option *ngFor="let entity of listEntities" [value]="entity.id">{{ entity.ref_data }}</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-select form-select-sm add_filter" [(ngModel)]="filters.entityBAccount" [disabled]="disableFilters" id="flt_accountb">
                        <option value="">- Entity B Account -</option>
                        <option *ngFor="let account of listAccountsB" [value]="account.id">{{ account.ref_data }}</option>
                      </select>
                    </td>
                    <td class="text-center" style="width: 125px !important">
                      <div style="display:inline-block" class="mt-1 pointer c_bonedk" title="Save" (click)="saveRow()">
                        <i class="fas fa-fw fa-lg fa-save"></i>
                      </div>
                      <div style="display:inline-block" class="mt-1 pointer c_bonedk" title="Reset/Cancel" (click)="resetFilters()">
                        <i class="fas fa-fw fa-lg fa-{{(saveMode == 'add') ? 'rotate' : 'times'}}"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
